export default __webpack_public_path__ + "static/media/car.3b52d913.svg";